module.exports = __webpack_public_path__ + "img/rc house.426e18b6.svg";